import PropTypes from 'prop-types'
import ReactSelect from 'react-select'
import { useTranslation } from 'react-i18next'

import SingleValue from './SingleValue'
import CustomOption from './CustomOption'

const Select = ({ options, value, setFieldValue, name, placeholder, disabled }) => {
  const { t } = useTranslation(['on-call-schedule'])

  return (
    <ReactSelect
      className="select-container"
      classNamePrefix="select-primary"
      options={options}
      name={name}
      value={value}
      components={{ Option: CustomOption, SingleValue }}
      placeholder={placeholder || t('on-call-schedule:select.selectItem')}
      onChange={(option) => setFieldValue(option)}
      isDisabled={disabled}
    />
  )
}

Select.propTypes = {
  row: PropTypes.object,
  cell: PropTypes.object,
  options: PropTypes.array.isRequired,
  value: PropTypes.object,
  setFieldValue: PropTypes.func.isRequired,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
}

export default Select
